import { find, findIndex, pullAt, filter, reject } from 'lodash';
var state = {
    loaded: false,
    categoryWaypoints: {},
    // TODO move customer base to here
    base: null,
    details: {},
    debugMode: false,
    gmapAPIKey: '',
    showGreetingMobile: true,
    showNewStoreWelcome: null,
    featureFlags: [],
    flows: [],
    completedRoute: null,
    backRoute: null,
    storeDeepLink: false,
    refreshKey: 1,
    onlineStatus: 1,
};
;
var getters = {
    loaded: function (state) { return state.loaded; },
    getWaypoints: function (state) { return state.categoryWaypoints; },
    getBaseLocation: function (state) { return state.base; },
    details: function (state) { return state.details; },
    debugMode: function (state) { return state.debugMode; },
    showGreetingMobile: function (state) { return state.showGreetingMobile; },
    getGmapAPIKey: function (state) { return state.gmapAPIKey; },
    showNewStoreWelcome: function (state) { return state.showNewStoreWelcome; },
    getFeatureFlag: function (state) { return function (name) {
        var featureMatch = find(state.featureFlags, function (feature) {
            if (feature && feature.name === name) {
                return feature.flag;
            }
        });
        return featureMatch;
    }; },
    getFlows: function (state) {
        var flows = state.flows;
        return flows;
    },
    getFlow: function (state) { return function (name) {
        var flows = state.flows;
        var match = find(flows, function (flow) {
            if (flow.name === name) {
                return flow;
            }
        });
        return match;
    }; },
    getFlowStep: function (state, getters) { return function (flowName, stepName) {
        var flow = getters.getFlow(flowName);
        if (!flow) {
            return null;
        }
        var steps = flow.steps;
        var match = find(steps, function (step) {
            if (step.name === stepName) {
                return step;
            }
        });
        return match;
    }; },
    getCompletedRoute: function (state) {
        return state.completedRoute;
    },
    getBackRoute: function (state) {
        return state.backRoute;
    },
    getStoreDeepLink: function (state) { return state.storeDeepLink; },
    getRefreshKey: function (state) { return state.refreshKey; },
    getOnlineStatus: function (state) { return state.onlineStatus; },
};
var actions = {
    setBaseLocation: function (_a, baseLocation) {
        var commit = _a.commit;
        commit('setBaseLocation', baseLocation);
    },
    setLoaded: function (_a, loaded) {
        var commit = _a.commit;
        commit('setLoaded', loaded);
    },
    setDetails: function (_a, details) {
        var commit = _a.commit;
        commit('setDetails', details);
    },
    setDebugMode: function (_a, isDebug) {
        var commit = _a.commit;
        commit('setDebugMode', isDebug);
    },
    setShowGreetingMobile: function (_a, showGreeting) {
        var commit = _a.commit;
        commit('setShowGreetingMobile', showGreeting);
    },
    setShowNewStoreWelcome: function (_a, showNewStoreWelcome) {
        var commit = _a.commit;
        commit('setShowNewStoreWelcome', showNewStoreWelcome);
    },
    setFeatureFlag: function (_a, _b) {
        var commit = _a.commit;
        var name = _b.name, flag = _b.flag;
        commit('setFeatureFlag', { name: name, flag: flag });
    },
    setFlow: function (_a, _b) {
        var commit = _a.commit;
        var name = _b.name, steps = _b.steps;
        commit('setFlow', { name: name, steps: steps });
    },
    setFlowStep: function (_a, _b) {
        var commit = _a.commit;
        var name = _b.name, step = _b.step, value = _b.value;
        // Set a particular Flow Events step flag
        var flowMatch = find(state.flows, function (flow) {
            if (flow.name === name) {
                return flow;
            }
        });
        var flowSteps = flowMatch.steps;
        var stepIndex = findIndex(flowSteps, function (flowStep) {
            if (step === flowStep.name) {
                return flowStep;
            }
        });
        flowSteps[stepIndex].value = value;
        var steps = flowSteps;
        commit('setFlow', { name: name, steps: steps });
    },
    setCompletedRoute: function (_a, completedRoute) {
        var commit = _a.commit;
        commit('setCompletedRoute', completedRoute);
    },
    setBackRoute: function (_a, backRoute) {
        var commit = _a.commit;
        commit('setBackRoute', backRoute);
    },
    setGmapAPIKey: function (_a, loaded) {
        var commit = _a.commit;
        commit('setGmapAPIKey', loaded);
    },
    setStoreDeepLink: function (_a, storeDeepLink) {
        var commit = _a.commit;
        commit('setStoreDeepLink', storeDeepLink);
    },
    updateRefreshKey: function (_a) {
        var commit = _a.commit;
        commit('updateRefreshKey');
    },
    setOnlineStatus: function (_a, status) {
        var commit = _a.commit;
        commit('setOnlineStatus', status);
    }
};
var mutations = {
    setBaseLocation: function (state, baseLocation) {
        state.base = baseLocation;
    },
    setLoaded: function (state, loaded) {
        state.loaded = loaded;
    },
    setCategoryWaypoint: function (state, waypoint) {
        var scroll = waypoint.scrollY;
        var value = waypoint.value;
        state.categoryWaypoints[value] = scroll;
    },
    setDetails: function (state, details) {
        state.details = details;
    },
    setDebugMode: function (state, isDebug) {
        state.debugMode = isDebug;
    },
    setShowGreetingMobile: function (state, showGreeting) {
        state.showGreetingMobile = showGreeting;
    },
    setShowNewStoreWelcome: function (state, showNewStoreWelcome) {
        state.showNewStoreWelcome = showNewStoreWelcome;
    },
    setFeatureFlag: function (state, _a) {
        var name = _a.name, flag = _a.flag;
        var predicate = function (feature) {
            return feature.name === name;
        };
        var otherFeatures = reject(state.featureFlags, predicate);
        state.featureFlags = otherFeatures;
        var filterFeatures = filter(state.featureFlags, predicate);
        var useFeature = filterFeatures[0] || { name: name, flag: flag };
        useFeature.flag = flag;
        state.featureFlags.push(useFeature);
    },
    setFlow: function (state, _a) {
        var name = _a.name, steps = _a.steps;
        var matchIndex = findIndex(state.flows, function (flow) {
            if (flow.name === name) {
                return flow;
            }
        });
        var flow = { name: name, steps: steps };
        if (matchIndex !== -1) {
            flow = pullAt(state.flows, matchIndex)[0];
        }
        flow.steps = steps;
        state.flows.push(flow);
    },
    setCompletedRoute: function (state, completedRoute) {
        state.completedRoute = completedRoute;
    },
    setBackRoute: function (state, backRoute) {
        state.backRoute = backRoute;
    },
    setGmapAPIKey: function (state, gmapAPIKey) {
        state.gmapAPIKey = gmapAPIKey;
    },
    setStoreDeepLink: function (state, storeDeepLink) {
        state.storeDeepLink = storeDeepLink;
    },
    updateRefreshKey: function (state) { return state.refreshKey++; },
    setOnlineStatus: function (state, status) {
        state.onlineStatus = status;
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/app.store.ts
// module id = null
// module chunks = 